import { Injectable } from "@angular/core";
import { Worker } from "../_types/worker";
import { Service } from "src/app/core/jsonapi/service";
import { AsyncSubject, Observable } from "rxjs";
import { ResponseCollection } from "src/app/core/jsonapi/responses/response-collection";

@Injectable({
    providedIn: 'root',
})
export class WorkersService extends Service<Worker> {
  public override type = 'workers';
  public override url = 'providers/workers'; 

  public sendMailLoginData(worker:Worker):Observable<any>{
    let url = this.getAPIUrl();
      let headers = {
          'Content-Type': 'application/vnd.api+json'
      };
      url = url + '/' + worker.id + "/sendmail/logindata"
      this.loaderService.skipRequest(url);
      return this.http.post(url , null, { headers: headers });
  }

  public getAvailability(cp?:string, capabilityId?:string|null, vehicleTypeId?:string|null, equipmentId?:string|null, includeGuardShift?:boolean|null): Observable<Worker[]> {
    let url = this.getAPIUrl() + '/Availability?include=workerGuardShifts';
    if (cp != null) url += '&cp=' + cp;
    if (capabilityId != null) url += '&capabilityId=' + capabilityId;
    if (vehicleTypeId != null) url += '&vehicleTypeId=' + vehicleTypeId;
    if (equipmentId != null) url += '&equipmentId=' + equipmentId;
    if (includeGuardShift != null) url += '&isGuard=' + includeGuardShift;
    let subject = new AsyncSubject<Worker[]>();
    this.http.get<Worker[]>(url).subscribe((response: Worker[]) => {
      /*response.forEach((data: Worker) => {
        this.fillRelationships(data, response);
        this.toLocalObject(data);
      });*/
      subject.next(response);
      subject.complete();
    });
    return subject.asObservable();
  }

}
